<template>
  <a-modal
    :title="title"
    :width="1450"
    :visible="visible"
    :footer="null"
    :ldata="data"
    @cancel="
      () => {
        this.isopen = false
        $emit('cancel',this.isopen)
      }
    "
  >
    <a-spin :spinning="loading">
      <a-button :title="isopen?'收缩':'展开'" type="primary" shape="circle" style="float:right;zIndex:2" @click="change">{{isopen?'-':'+'}}</a-button>
      <!-- <div id="lossChart" style="width: 90%; height: 200px"></div> -->
      <a-table :scroll="{ y: 800 }" :columns="columns" :data-source="data" :pagination="false"> </a-table>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { requestUrl } from '@/utils/request_url'
export default {
  name: 'ProjectForm',
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    ldata: {
      type: Array,
      default: () => null,
    },
    title: {
      type: String,
      default: '新增',
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      headers: {},
      columns: [
        {
          dataIndex: 'lr',
          key: 'lr',
          title: 'LR',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: 'EPOCH',
          dataIndex: 'epoch',
          key: 'epoch',
        },
        {
          title: 'STEP',
          dataIndex: 'step',
          key: 'step',
        },
        {
          title: 'LOSS',
          key: 'loss',
          dataIndex: 'loss',
        },
        {
          title: 'TEST_RECALL',
          key: 'test_recall',
          dataIndex: 'test_recall',
        },
         {
          title: 'TEST_PRECISION',
          key: 'test_precision',
          dataIndex: 'test_precision',
        },
        {
          title: 'TRAIN_ACCURACY',
          key: 'train_accuracy',
          dataIndex: 'train_accuracy',
        },
         {
          title: 'VAL_ACCURACY',
          key: 'val_accuracy',
          dataIndex: 'val_accuracy',
        },
        {
          title: '时间',
          key: 'createTime',
          dataIndex: 'createTime',
        },
      ],
      data: [],
      dom:null,
      xData: [],
      yData: [],
      isopen: false
    }
  },
  created() {
    // this.$nextTick(() => {
    // })
  },
  watch: {
    ldata: function (newValue, oldValue) {
      this.data = newValue
    },
  },
  computed: {},
  mounted() {
    // const self = this
    // this.$nextTick(() => {
    //   self.drawChart()
    // })
  },
  methods: {
    init(){
       
    },
    change(){
      this.isopen = !this.isopen
      this.$emit('isopen',this.isopen)
    },
    drawChart() {
      let myChart = this.$echarts.init(document.getElementById('lossChart'))
      let option = {
        xAxis: {
          type: 'category',
          data: this.xData
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data:this.yData,
            type: 'line',
          },
        ],
      }

      myChart.setOption(option)

      // 使用刚指定的配置项和数据显示图表。
    },
  },
}
</script>

<style scoped>
.ant-table-body {
  overflow-y: auto !important;
}
</style>
